import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  divider: {
    marginBlock: 16
  },

  logo: {
    width: '135px',
    height: '56px !important'
  },

  sider: {
    '.ant-menu .ant-menu-item-selected': {
      backgroundColor: `${token.colorPrimary}20`,
      color: token.colorPrimary
    },
    '.ant-layout-sider-children': {
      backgroundColor: token.colorWhite,
      paddingInline: '0 !important',

      '.ant-pro-sider-extra': {
        marginInline: 0,
        marginTop: 16
      }
    },
    '.ant-layout-header.ant-pro-layout-header': {
      backgroundColor: `${token.colorWhite} !important`
    },
    '.ant-pro-base-menu-vertical-item-icon': {
      width: 24,
      height: 24
    },
    '.ant-menu-item': {
      paddingInline: `16px !important`
    },
    '.ant-pro-sider-collapsed-button': {
      insetBlockStart: 22
    },
    '.ant-pro-layout-content': {
      paddingBlock: 24,
      paddingInline: 24
      // backgroundColor: token.colorWhite
    }
  },

  accountDetails: {
    lineHeight: token.lineHeight
  }
}))
